import React from 'react';
import {
        Show,
        ShowButton,
        Tab,
        TabbedShowLayout,
        DateField,
        List,
        Edit,
        Create,
        Datagrid,
        TextField,
        NumberField,
        EditButton,
        ReferenceInput,
        ReferenceManyField,
        SingleFieldList,
        ChipField,
        SelectInput,
        SimpleForm,
        TextInput,
        NumberInput,
        Filter,
} from 'react-admin';

import LinkAnyFieldButton from './LinkAnyFieldButton';


const ScopeFilter = props => (
    <Filter {...props}>
        <TextInput label="Search" source="q" alwaysOn />
        <ReferenceInput
            label="Name Space"
            source="nameSpace"
            reference="nameSpace"
            allowEmpty
        >
            <SelectInput optionText="firstName" />
        </ReferenceInput>
    </Filter>
);

export const ScopeList = props => (
    <List {...props} filters={<ScopeFilter />}>
        <Datagrid>
            <TextField source="name" />
                <TextField source="nameSpace" />
            <NumberField source="expires" />
            <ReferenceManyField label="Clients" reference="ClientScopeView" target="scopeId" linkType="none" >
                <SingleFieldList linkType={false} >
                    <LinkAnyFieldButton to="/Client/:clientId/show">
                        <ChipField source="clientName" />
                    </LinkAnyFieldButton>
                </SingleFieldList>
             </ReferenceManyField>
            <EditButton />
            <ShowButton />
        </Datagrid>
    </List>
);

const ScopeTitle = ({ record }) => {
    return <span>Scope {record ? `"${record.nameSpace} / ${record.name}"` : ''}</span>;
};

export const ScopeEdit = props => (
    <Edit title={<ScopeTitle />} {...props}>
        <SimpleForm>
            <TextInput disabled source="id" />
            <TextInput source="name" />
            <TextInput source="nameSpace" />
            <NumberInput source="expires" />
        </SimpleForm>
    </Edit>
);

export const ScopeCreate = props => (
    <Create {...props}>
        <SimpleForm>
            <TextInput source="name" />
            <TextInput source="nameSpace" />
            <NumberInput source="expires" />
        </SimpleForm>
    </Create>
);

export const ScopeShow = props => (
    <Show title={<ScopeTitle />} {...props}>
        <TabbedShowLayout>
            <Tab label="summary" >
                <TextField source="name" />
                <TextField source="nameSpace" />
                <NumberField source="expires" />
                <DateField label="Publication date" source="createdAt" />
            </Tab>
            <Tab label="Usage" >
                <ReferenceManyField label="Clients" reference="ClientScopeView" target="scopeId" linkType="none" >
                    <SingleFieldList linkType={false} >
                        <LinkAnyFieldButton to="/Client/:clientId/show">
                            <ChipField source="clientName" />
                        </LinkAnyFieldButton>
                    </SingleFieldList>
                </ReferenceManyField>
                <ReferenceManyField label="Public claims" reference="ScopeRuleView" target="scopeId" >
                    <SingleFieldList linkType={false} >
                        <LinkAnyFieldButton to="/Rule/:ruleId/show">
                            <ChipField source="ruleName" />
                        </LinkAnyFieldButton>
                    </SingleFieldList>
                </ReferenceManyField>
                <ReferenceManyField label="Token claims" reference="ScopeTokenruleView" target="scopeId" linkType="none" >
                    <SingleFieldList linkType={false} >
                        <LinkAnyFieldButton to="/Rule/:ruleId/show">
                            <ChipField source="ruleName" />
                        </LinkAnyFieldButton>
                    </SingleFieldList>
                </ReferenceManyField>
            </Tab>
        </TabbedShowLayout>
    </Show>
);
